module.exports = __webpack_public_path__ + "media/images/regional-image1-436f9b13e445c075c4af1bf3ba15a41d.jpg";